import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { Form, Row, Col, Radio } from "antd";
import {
  Input,
  Select,
  DatePicker,
  RadioGroup,
  Button,
  Typography,
} from "../core";
import { MixStyle } from "../styles";
import { addPayment } from "../redux/Action/payment";
import { getCompanyId } from "../helper/utils/companyId";

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const PaymentOption = ["check", "cash"];
const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const AddPayment = ({
  data: { contract_id, contract_type, buyer_id, company_id: companyIdProp },
  form,
  onCancel,
  onCreate,
  rest,
}) => {
  const { token } = useSelector((state) => state.auth);

  const company_id = companyIdProp || getCompanyId();
  const dispatch = useDispatch();
  const [payment, setPayment] = React.useState({});
  const onFinish = (values) => {
    dispatch(addPayment(payment, token));
    form.resetFields();
    onCreate();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const onValuesChange = (changedValues, valuse) => {
    const {
      payment_date,
      payment_amount,
      payment_method,
      payment_option,
      description,
    } = valuse;
    setPayment((prev) => ({
      payment_date,
      payment_amount,
      payment_method,
      payment_option,
      description,
      buyer_id,
      contract_id,
      contract_type,
      company_id,
    }));
  };
  const selctData = ["cash", "cheque"];
  return (
    <StyledForm
      autocomplete="off"
      form={form}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onValuesChange={onValuesChange}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row
        gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
        type="flex"
        justify="center"
      >
        <Col md={12} sm={18} xs={24}>
          <Form.Item
            label="Date"
            name="payment_date"
            rules={[
              {
                required: true,
                message: "Please Set Date!",
              },
            ]}
          >
            <DatePicker />
          </Form.Item>
        </Col>
        <Col md={12} sm={18} xs={24}>
          <Form.Item
            label="Ammount"
            name="payment_amount"
            rules={[
              {
                required: true,
                message: "Please Enter Ammount!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col md={12} sm={18} xs={24}>
          <Form.Item
            label="Payment Method"
            name="payment_method"
            rules={[
              {
                required: true,
                message: "Please select Payment Method ",
              },
            ]}
          >
            <Select
              placeholder="Payment Method"
              selctData={selctData}
              Options={PaymentOption}
            />
          </Form.Item>
        </Col>
        <Col md={12} sm={18} xs={24}>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: false,
                message: "Please Enter Description!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col md={12} sm={18} xs={24}>
          <Form.Item
            name="payment_option"
            label="Payment Status"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject("Please Select one"),
              },
            ]}
          >
            <RadioGroup placement="end-to-end">
              <Radio value="paid">Paid</Radio>
              <Radio value="receive">Receive</Radio>
            </RadioGroup>
          </Form.Item>
        </Col>
        {/* <Col md={12} sm={18} xs={24}></Col> */}
        <Col md={13} sm={18} xs={24}>
          <Row type="flex" justify="space-between">
            <Col sm={10}>
              <Button bg="#404E67" type="primary" htmlType="submit">
                <Typography
                  text="Add"
                  as="h5"
                  noMargin
                  weight="bold"
                  align="center"
                  color="white"
                />
              </Button>
            </Col>
            <Col sm={10}>
              <Button bg="#404E67" type="primary" onClick={onCancel}>
                <Typography
                  text="Cancel"
                  as="h5"
                  noMargin
                  weight="bold"
                  align="center"
                  color="white"
                />
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledForm>
  );
};
export default AddPayment;
